
import request from '@/utils/http';

// 进度
export const getStep = (params) => {
    return request({
        url: `/api-tms/transport/selectstate/${params}`,
        method: 'get'
    });
};

// 综合信息
export const getAllMassage = (params) => {
    return request({
        url: `api-tms/transport/selectbytaskno/${params}`,
        method: 'get'
    });
};
// 商品信息
export const goodsDetails = (params) => {
    return request({
        url: `/api-tms/transport/searchgoodsdetail/${params}`,
        method: 'get'
    });
};
// 日志
export const transportLogs = (params) => {
    return request({
        url: `/api-tms/transportTraces/selectlogsinfo/${params}`,
        method: 'get'
    });
};
// 列表
export const transportData = (data) => {
    return request({
        url: `/api-tms/transport/selectallPage`,
        method: 'post',
        data
    });
};
// 修改地址
export const changeAddress = (data) => {
    return request({
        url: `/api-tms/transport/addressUpdate`,
        method: 'post',
        data
    });
};
// 下发零担平台
export const sendToLtlPlatForm = (data) => {
    return request({
        url: `/api-tms/transport/sendToLtlPlatForm`,
        method: 'post',
        data
    });
};
// 撤销零担平台
export const revokeToLtlPlatForm = (data) => {
    return request({
        url: `/api-tms/transport/revokeToLtlPlatForm`,
        method: 'post',
        data
    });
};
// 获取零担平台参数
export const getToLtlPlatFormList = (data) => {
    return request({
        url: `/api-tms/transport/getToLtlPlatFormList`,
        method: 'post',
        data
    });
};

// 查询库存流水总数量
export const getTotalCounts = (data) => {
    return request({
        url: `/api-tms/transport/selectAllTransportsCount`,
        method: 'post',
        data
    });
};
// 脱敏查询接口
export const saveInformationSecurityLog = (data) => {
    return request({
        method: 'post',
        url: `/api-tms/desensitization/data/access/log/add`,
        data
    });
};
